import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/PageHeader";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import useIntegration from "../../../utils/useIntegration";
import SlashdataPolicyCreateForm from "./forms/slashdata-policy-create-form";
import ShafafiyaPolicyCreateForm from "./forms/shafafiya-policy-create-form";
const CURRENT_DAY = `0${new Date().getDate()}`.slice(-2);
const CURRENT_MONTH = `0${new Date().getMonth() + 1}`.slice(-2);
const CURRENT_YEAR = new Date().getFullYear().toString();
function PolicyCreate() {
  const { t } = useTranslation();
  const [date, setDate] = useState({
    day: CURRENT_DAY,
    month: CURRENT_MONTH,
    year: CURRENT_YEAR,
  });
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { integration } = useIntegration();
  return (
    <DashboardLayout>
      <PageHeader
        back="/policies"
        title={
          integration?.integrationType === "shafafiya"
            ? t("policy.create_member")
            : t("policy.create_policy")
        }
        description={
          integration?.integrationType === "shafafiya"
            ? t("policy.create_shafafiya_member_description")
            : t("policy.create_policy_description")
        }
      />

      <div className="mt-6">
        {integration?.integrationType === "slashdata" && (
          <SlashdataPolicyCreateForm integration={integration} />
        )}
        {integration?.integrationType === "shafafiya" && (
          <ShafafiyaPolicyCreateForm integration={integration} />
        )}
        {!integration && (
          <div className="flex items-center justify-center h-40 text-gray-500 font-light text-xl">
            {t("Select an integration from the sidebar to continue.")}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
export default PolicyCreate;
